<template>
    <base-step-list title="Camp setup"
                    :current-step="currentStep"
                    :steps="steps"
                    :is-disabled="isDisabled"
                    :next-callback="next"
                    :go-to-callback="goTo"
                    :save-draft-callback="saveDraft"
                    :is-draft="isFormDraft" 
                    >
    </base-step-list>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import BaseStepList from '@/components/main/pages/base/BaseStepList';

    export default {
        name: 'StepProgress',
        components: {BaseStepList},
        computed: {
            ...mapGetters({
                currentStep: 'campCreationStep',
                steps: 'campCreationSteps',
                isDisabled: 'campCreationFormDisabled',
                isFormDraft: 'isCampFormDraft'
            }),
        },
        methods: {
            ...mapActions({
                next: 'campCreationNextStep',
                goTo: 'goToCampCreationStep',
                saveDraft: 'saveDraftCamp'
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/StepProgress.vue